import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { useQuery } from 'glimmer-apollo';
import { GET_HOME_PAGE_PAGINATED } from 'embroil/gql/queries/home-page-paginated';

export default class IndexRoute extends Route {
  @service head;

  queryParams = {
    page: {
      refreshModel: true
    }
  };

  async model(params) {
    const page = parseInt(params.page) || 1;
    const limit = 8;

    // Set canonical URL and robots meta for pagination
    const baseUrl = 'https://1vx.gg/';
    if (page > 1) {
      // For page 2+, set canonical to base URL and noindex
      this.head.updateMeta({
        canonical: baseUrl,
        robots: 'noindex,follow'
      });
    } else {
      // For page 1, just set canonical to base URL
      this.head.updateMeta({
        canonical: baseUrl,
        robots: ''
      });
    }

    const query = useQuery(this, () => [
      GET_HOME_PAGE_PAGINATED,
      { variables: { page, limit } }
    ]);

    await query.promise;

    // Combine different article types for mixed top news
    const topNews = [
      ...(query.data.topGameArticles || []),
      ...(query.data.topESportsArticles || [])
    ];

    // Combine different article types for popular posts
    const popularPosts = [
      ...(query.data.popularGameArticles || []),
      ...(query.data.popularESportsArticles || [])
    ];

    // Get paginated article data
    const eSportsData = query.data.eSportsArticles || {};
    const gameData = query.data.gameArticles || {};

    // Combine and sort articles from both types
    const allArticles = [
      ...(eSportsData.items || []),
      ...(gameData.items || [])
    ].sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));

    // Calculate combined pagination
    const totalCount = (eSportsData.totalCount || 0) + (gameData.totalCount || 0);
    const hasNextPage = eSportsData.hasNextPage || gameData.hasNextPage;
    const hasPreviousPage = eSportsData.hasPreviousPage || gameData.hasPreviousPage;

    return {
      articles: allArticles,
      topNews: topNews,
      newsSlider: query.data.newsSlider,
      popularPosts: popularPosts,
      // Pagination data
      pagination: {
        currentPage: page,
        totalCount: totalCount,
        limit: limit,
        hasNextPage: hasNextPage,
        hasPreviousPage: hasPreviousPage
      }
    };
  }
}
